import React from 'react';

const ProfileShipping = () => {
  return <span>En construcción</span>;
};

export default ProfileShipping;
